<script setup lang="ts">
import { useHubSpotLoader } from '~/composables/useHubSpotLoader'

const props = defineProps<{
  model: {
    formTitle?: { value: string }
    formPortalId: { value: string }
    formId: { value: string }
    containerClass: { value: string }
    blockSpacing: boolean
  }
  prefill?: Record<string, string | undefined>
}>()

const portalId = computed(() => props.model.formPortalId.value)
const formId = computed(() => props.model.formId.value)
const containerClass = computed(() => props.model.containerClass?.value || 'hs-180-form prose')
const useBlockSpacing = computed(() => props.model.blockSpacing ?? true) // using block-spacing as the default, must opt out

const containerId = `hubspotFormLocation-${props.model.formId.value}`

useHubSpotFormA11y(containerId, props.model.formTitle?.value)
useHubSpotFormPrefill(containerId, () => props.prefill ?? {})

onMounted(async () => {
  await useHubSpotLoader(portalId.value)
})
</script>

<template>
  <div
    :id="containerId"
    class="hs-form-html"
    :class="[{ 'block-spacing': useBlockSpacing }, containerClass]"
    data-region="na1"
    :data-portal-id="portalId"
    :data-form-id="formId"
  />
</template>

<style lang="scss">
@use '@/assets/css/forms/hubspot-form.scss';
</style>
